<template>
  <div class="penalty-free-mobile">
    <TopNavBarMobile :classId="classId" :subjectIndex="0" />

    <div class="pf-content">
      <!-- 头部卡片 -->
      <div class="pf-header">
        <div class="pf-title-row">
          <div class="pf-title-left">
            <div class="pf-title-line">
              <el-button class="back-btn" @click="goBack" icon="el-icon-arrow-left" size="small">返回</el-button>
              <div class="pf-title">不罚</div>
            </div>
            <div class="pf-subtitle">罚不是目的，罚是为了不罚。</div>
          </div>
          <div class="pf-title-actions">
            <el-button class="pf-exemplary-btn" size="small" icon="el-icon-trophy" @click="openExemplaryDialog">守纪标兵</el-button>
          </div>
        </div>
        <div class="pf-switch-row">
          <div class="pf-switch-left">
            <span class="pf-switch-label">只看罚站</span>
            <el-switch v-model="onlyPenalized"></el-switch>
          </div>
          <div class="pf-switch-actions">
            <el-button class="pf-setting-btn" size="small" icon="el-icon-setting" @click="openSetting"></el-button>
            <el-button class="pf-add-btn" size="small" icon="el-icon-plus" @click="openAddDialog">添加惩罚</el-button>
          </div>
        </div>
      </div>

      <!-- 列表 -->
      <div class="pf-table-card">
        <el-table
          ref="penaltyTable"
          class="pf-drag-scroll"
          :data="displayRows"
          v-loading="loading"
          size="mini"
          style="width: 100%"
          empty-text="暂无数据"
          :default-sort="{ prop: 'studentNumber', order: 'ascending' }"
          @sort-change="handleSortChange"
        >
          <el-table-column prop="studentNumber" label="学号" sortable="custom" min-width="78"></el-table-column>
          <el-table-column prop="name" label="姓名" min-width="80"></el-table-column>
          <el-table-column prop="remainingDays" label="剩余天数" sortable="custom" min-width="102">
            <template slot-scope="scope">{{ scope.row.remainingDays > 0 ? scope.row.remainingDays : '-' }}</template>
          </el-table-column>
          <el-table-column prop="endDate" label="站完日期" sortable="custom" min-width="110">
            <template slot-scope="scope">{{ fmtDateFull(scope.row.endDate) }}</template>
          </el-table-column>
          <el-table-column prop="disciplineDays" label="守纪天数" sortable="custom" min-width="102">
            <template slot-scope="scope">{{ scope.row.disciplineDays != null ? scope.row.disciplineDays : '-' }}</template>
          </el-table-column>
          <el-table-column label="其它功能" width="76">
            <template slot-scope="scope">
              <el-button type="text" size="mini" class="pf-action-btn" @click="openDetailDialog(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 添加惩罚弹窗 -->
    <el-dialog title="添加惩罚" :visible.sync="addDialogVisible" append-to-body width="92%" class="pf-dialog">
      <el-form label-position="top" size="small">
        <el-form-item label="学生（可多选）" required>
          <el-select
            v-model="addForm.studentIds"
            multiple
            filterable
            placeholder="选择学生"
            style="width: 100%"
          >
            <el-option
              v-for="s in allRows"
              :key="s.studentId"
              :label="s.studentNumber + ' ' + s.name"
              :value="s.studentId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处罚时间" required>
          <div class="pf-datetime-row">
            <el-date-picker
              v-model="addForm.punishDate"
              type="date"
              format="MM月dd日"
              value-format="yyyy-MM-dd"
              :first-day-of-week="1"
              :clearable="false"
              :editable="false"
              :picker-options="datePickerOptions"
              placeholder="选择日期"
              style="flex: 1; min-width: 0"
            ></el-date-picker>
            <el-radio-group v-model="addForm.punishPeriod" class="pf-period-group">
              <el-radio :label="1">上午</el-radio>
              <el-radio :label="2">下午</el-radio>
            </el-radio-group>
          </div>
          <div class="pf-tip">处罚时间不能选周六、周日；下午处罚时当天下午也罚站，正式天数从下一个上课日起算</div>
        </el-form-item>
        <el-form-item label="违纪内容" required>
          <el-input type="textarea" :rows="2" v-model="addForm.violationContent" placeholder="请输入违纪内容"></el-input>
        </el-form-item>
        <el-form-item label="罚站天数" required>
          <el-input-number v-model="addForm.days" :min="1" :max="99" class="pf-days-number" style="width: 130px"></el-input-number>
        </el-form-item>
        <el-form-item>
          <template slot="label"><span class="pf-label-placeholder">*</span>限制减罚</template>
          <div class="pf-restrict-row">
            <el-switch v-model="addForm.restrictReduce"></el-switch>
            <span class="pf-restrict-tip">所犯错误严重时打开，该条记录将无法减罚</span>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="pf-dialog-footer">
        <el-button size="small" @click="addDialogVisible = false">取消</el-button>
        <el-button size="small" class="pf-primary-btn" @click="submitAdd">确定</el-button>
      </div>
    </el-dialog>

    <!-- 减罚弹窗（绑定具体罚站记录） -->
    <el-dialog
      :title="'为' + (reduceTarget.studentName || '') + '减罚'"
      :visible.sync="reduceDialogVisible"
      append-to-body
      width="88%"
      class="pf-dialog"
    >
      <div class="pf-reduce-context">
        <div>处罚时间：{{ reduceTarget.punishLabel }}</div>
        <div>登记 {{ reduceTarget.days }} 天 · 当前生效 {{ reduceTarget.effectiveDays }} 天</div>
      </div>
      <el-form label-position="top" size="small">
        <el-form-item label="减罚天数" required>
          <el-input-number
            v-model="reduceForm.reduceDays"
            :min="1"
            :max="reduceTarget.effectiveDays || 1"
            class="pf-days-number"
            style="width: 100%"
          ></el-input-number>
          <div class="pf-tip">减罚只作用于本次处罚，最多可减 {{ reduceTarget.effectiveDays }} 天</div>
        </el-form-item>
        <el-form-item label="原因">
          <el-input type="textarea" :rows="2" v-model="reduceForm.reason" placeholder="减罚原因（选填），如：做好事、拾金不昧"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="pf-dialog-footer">
        <el-button size="small" @click="reduceDialogVisible = false">取消</el-button>
        <el-button size="small" class="pf-primary-btn" @click="submitReduce">确定</el-button>
      </div>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog
      :title="(detailTarget.name || '') + '罚站记录'"
      :visible.sync="detailDialogVisible"
      append-to-body
      width="94%"
      top="6vh"
      class="pf-dialog pf-detail-dialog"
    >
      <el-tabs v-model="detailTab" stretch>
        <el-tab-pane label="罚站记录" name="penalty">
          <el-table
            ref="detailPenaltyTable"
            :data="detailPenaltyRows"
            size="mini"
            class="pf-detail-table pf-drag-scroll"
            style="width: 100%"
            max-height="320"
            empty-text="暂无罚站记录"
            :default-sort="{ prop: 'punishDate', order: 'descending' }"
            :row-class-name="penaltyRowClass"
            @sort-change="handleDetailPenaltySort"
          >
            <el-table-column prop="punishDate" label="处罚时间" sortable="custom" min-width="172" show-overflow-tooltip>
              <template slot-scope="scope">{{ fmtDateFull(scope.row.punishDate) }} {{ scope.row.punishPeriod === 2 ? '下午' : '上午' }}</template>
            </el-table-column>
            <el-table-column prop="violationContent" label="违纪内容" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="days" label="登记天数" sortable="custom" min-width="128" show-overflow-tooltip>
              <template slot-scope="scope">{{ daysFormula(scope.row) }}</template>
            </el-table-column>
            <el-table-column prop="endDate" label="站完日期" sortable="custom" min-width="152" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.currentDays === 0 ? '已减完' : fmtDateFull(scope.row.endDate) }}</template>
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="88" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" min-width="160" class-name="pf-op-col">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  class="pf-action-btn"
                  :class="{ 'pf-btn-disabled': scope.row.restrictReduce === 1 }"
                  @click="onReduceClick(scope.row)"
                >减罚</el-button>
                <el-button type="text" size="mini" class="pf-action-btn" @click="openEditDialog(scope.row)">编辑</el-button>
                <el-button type="text" size="mini" class="pf-del-btn" @click="delPenaltyRecord(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="减罚记录" name="reduce">
          <el-table
            ref="detailReduceTable"
            :data="detailReduceRows"
            size="mini"
            class="pf-detail-table pf-drag-scroll"
            style="width: 100%"
            max-height="320"
            empty-text="暂无减罚记录"
            :default-sort="{ prop: 'createdAt', order: 'descending' }"
            @sort-change="handleDetailReduceSort"
          >
            <el-table-column prop="createdAt" label="登记时间" sortable="custom" min-width="152" show-overflow-tooltip>
              <template slot-scope="scope">{{ fmtDateFull(scope.row.createdAt) }}</template>
            </el-table-column>
            <el-table-column label="减罚对象" min-width="138" show-overflow-tooltip>
              <template slot-scope="scope">{{ recordLabel(scope.row.recordId) }}</template>
            </el-table-column>
            <el-table-column prop="reduceDays" label="减罚天数" sortable="custom" min-width="106" show-overflow-tooltip></el-table-column>
            <el-table-column prop="reason" label="原因" min-width="128" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" min-width="62" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="mini" class="pf-del-btn" @click="delReduction(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!-- 编辑惩罚弹窗 -->
    <el-dialog
      :title="'编辑' + (editTarget.name || '') + '的处罚'"
      :visible.sync="editDialogVisible"
      append-to-body
      width="92%"
      class="pf-dialog"
    >
      <el-form label-position="top" size="small">
        <el-form-item label="处罚时间" required>
          <div class="pf-datetime-row">
            <el-date-picker
              v-model="editForm.punishDate"
              type="date"
              format="MM月dd日"
              value-format="yyyy-MM-dd"
              :first-day-of-week="1"
              :clearable="false"
              :editable="false"
              :picker-options="datePickerOptions"
              placeholder="选择日期"
              style="flex: 1; min-width: 0"
            ></el-date-picker>
            <el-radio-group v-model="editForm.punishPeriod" class="pf-period-group">
              <el-radio :label="1">上午</el-radio>
              <el-radio :label="2">下午</el-radio>
            </el-radio-group>
          </div>
          <div class="pf-tip">修改处罚时间或天数后，该生的罚站接龙将自动重排</div>
        </el-form-item>
        <el-form-item label="违纪内容" required>
          <el-input type="textarea" :rows="2" v-model="editForm.violationContent" placeholder="请输入违纪内容"></el-input>
        </el-form-item>
        <el-form-item label="罚站天数" required>
          <el-input-number v-model="editForm.days" :min="1" :max="99" class="pf-days-number" style="width: 130px"></el-input-number>
        </el-form-item>
        <el-form-item>
          <template slot="label"><span class="pf-label-placeholder">*</span>限制减罚</template>
          <div class="pf-restrict-row">
            <el-switch v-model="editForm.restrictReduce"></el-switch>
            <span class="pf-restrict-tip">所犯错误严重时打开，该条记录将无法新增减罚</span>
          </div>
        </el-form-item>
        <el-form-item label="关联减罚记录">
          <div v-if="!editReductions.length" class="pf-tip">该条处罚暂无减罚记录</div>
          <div v-for="r in editReductions" :key="r.id" class="pf-edit-reduction-row">
            <template v-if="editingReductionId === r.id">
              <el-input-number
                v-model="editReductionForm.reduceDays"
                :min="1"
                :max="editForm.days"
                size="mini"
                class="pf-days-number"
                style="width: 100px"
              ></el-input-number>
              <el-input v-model="editReductionForm.reason" size="mini" placeholder="原因" style="flex: 1; min-width: 0"></el-input>
              <el-button type="text" size="mini" class="pf-action-btn" @click="saveEditReduction(r)">保存</el-button>
              <el-button type="text" size="mini" @click="editingReductionId = null">取消</el-button>
            </template>
            <template v-else>
              <span class="pf-er-days">减 {{ r.reduceDays }} 天</span>
              <span class="pf-er-reason">{{ r.reason || '（无原因）' }}</span>
              <el-button type="text" size="mini" class="pf-action-btn" @click="startEditReduction(r)">修改</el-button>
              <el-button type="text" size="mini" class="pf-del-btn" @click="delEditReduction(r)">删除</el-button>
            </template>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="pf-dialog-footer">
        <el-button size="small" @click="editDialogVisible = false">取消</el-button>
        <el-button size="small" class="pf-primary-btn" @click="submitEdit">保存</el-button>
      </div>
    </el-dialog>

    <!-- 守纪标兵弹窗：展示从未被罚站过的学生 -->
    <el-dialog title="守纪标兵" :visible.sync="exemplaryDialogVisible" append-to-body width="88%" class="pf-dialog pf-exemplary-dialog">
      <div class="pf-exemplary-banner">
        <i class="el-icon-trophy pf-exemplary-medal"></i>
        <div class="pf-exemplary-title">本班守纪标兵</div>
        <div class="pf-exemplary-slogan">
          <span class="pf-exemplary-slogan-main">从未罚站，始终如一</span>
          <span class="pf-exemplary-slogan-sub">——你们是全班最好的榜样！</span>
        </div>
      </div>
      <div class="pf-exemplary-list">
        <div v-for="s in exemplaryRows" :key="s.studentId" class="pf-exemplary-item">
          <span class="pf-exemplary-no">{{ s.studentNumber }}</span>
          <span class="pf-exemplary-name">{{ s.name }}</span>
          <i class="el-icon-circle-check pf-exemplary-check"></i>
        </div>
      </div>
      <div v-if="exemplaryRows.length === 0" class="pf-exemplary-empty">暂无守纪标兵，大家一起加油，从零罚站开始！</div>
      <div v-else class="pf-exemplary-footer">守纪是最高级的自律，为以上 {{ exemplaryRows.length }} 位同学点赞！</div>
    </el-dialog>

    <!-- 不罚设置弹窗 -->
    <el-dialog title="不罚设置" :visible.sync="settingDialogVisible" append-to-body width="88%" class="pf-dialog">
      <el-form label-position="top" size="small">
        <el-form-item label="开学日期" required>
          <el-date-picker
            v-model="settingForm.semesterStartDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :first-day-of-week="1"
            :clearable="false"
            :editable="false"
            placeholder="选择开学日期"
            style="width: 100%"
          ></el-date-picker>
          <div class="pf-tip">开学日所在的自然周（周一至周日）为第一周，开学日若是周日则为第一周最后一天。设置后日期显示为"月-日(第几周/周几)"，如 09-08(2/2) 表示第二周周二</div>
        </el-form-item>
        <el-form-item label="补课日期">
          <el-date-picker
            v-model="settingForm.makeupDates"
            type="dates"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="makeupPickerOptions"
            :clearable="true"
            :editable="false"
            placeholder="选择需补课的周六/周日"
            style="width: 100%"
          ></el-date-picker>
          <div class="pf-tip">国庆、中秋等调休后需要补课的周末日期，选中后这些周末按上课日参与罚站排期、剩余天数与守纪天数计算</div>
        </el-form-item>
      </el-form>
      <div class="pf-danger-zone">
        <el-button size="small" class="pf-danger-btn" @click="clearAllPenalties">清空所有罚站与减罚记录</el-button>
        <div class="pf-tip">删除本班所有学生的罚站与减罚记录（含历史），操作不可恢复</div>
      </div>
      <div slot="footer" class="pf-dialog-footer">
        <el-button size="small" @click="settingDialogVisible = false">取消</el-button>
        <el-button size="small" class="pf-primary-btn" @click="submitSetting">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TopNavBarMobile from '@/components/mobile/TopNavBarMobile.vue'

export default {
  name: 'PenaltyFreeMobile',
  components: {
    TopNavBarMobile
  },
  props: {
    classId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      onlyPenalized: true,
      allRows: [],
      loading: false,
      semesterStart: null,
      makeupDateStrings: [],
      settingDialogVisible: false,
      settingForm: {
        semesterStartDate: '',
        makeupDates: []
      },
      lastSort: {
        field: 'studentNumber',
        order: 'ascending'
      },
      addDialogVisible: false,
      addForm: {
        studentIds: [],
        punishDate: '',
        punishPeriod: 1,
        violationContent: '',
        days: 1,
        restrictReduce: false
      },
      datePickerOptions: {
        firstDayOfWeek: 1,
        // 周末默认禁选，调休补课的周末（makeupDateStrings）放开可选
        disabledDate: (time) => {
          const d = new Date(time).getDay()
          if (d !== 0 && d !== 6) return false
          const key = this.fmtDate(new Date(time))
          return !(this.makeupDateStrings || []).includes(key)
        }
      },
      makeupPickerOptions: {
        firstDayOfWeek: 1,
        // 补课日期只允许选周六、周日
        disabledDate(time) {
          const d = new Date(time).getDay()
          return d !== 0 && d !== 6
        }
      },
      reduceDialogVisible: false,
      exemplaryDialogVisible: false,
      reduceTarget: {
        recordId: null,
        studentName: '',
        punishLabel: '',
        days: 0,
        effectiveDays: 0
      },
      reduceForm: {
        reduceDays: 1,
        reason: ''
      },
      editDialogVisible: false,
      editTarget: {
        studentId: null,
        name: ''
      },
      editForm: {
        id: null,
        punishDate: '',
        punishPeriod: 1,
        violationContent: '',
        days: 1,
        restrictReduce: false
      },
      editReductions: [],
      editingReductionId: null,
      editReductionForm: {
        reduceDays: 1,
        reason: ''
      },
      detailDialogVisible: false,
      detailTarget: {
        studentId: null,
        name: ''
      },
      detailTab: 'penalty',
      lastPenaltySort: {
        field: 'punishDate',
        order: 'descending'
      },
      lastReduceSort: {
        field: 'createdAt',
        order: 'descending'
      },
      detail: {
        penaltyRecords: [],
        reductions: []
      }
    }
  },
  computed: {
    detailPenaltyRows() {
      const rows = (this.detail.penaltyRecords || []).slice()
      const { field, order } = this.lastPenaltySort
      const dir = order === 'descending' ? -1 : 1
      rows.sort((a, b) => {
        let va = 0
        let vb = 0
        if (field === 'punishDate') {
          // 同一天按时段排：下午(2)视为晚于上午(1)
          va = (a.punishDate ? new Date(a.punishDate).getTime() : 0) * 10 + (a.punishPeriod === 2 ? 1 : 0)
          vb = (b.punishDate ? new Date(b.punishDate).getTime() : 0) * 10 + (b.punishPeriod === 2 ? 1 : 0)
        } else if (field === 'days') {
          va = a.days || 0
          vb = b.days || 0
        } else if (field === 'endDate') {
          va = a.endDate ? new Date(a.endDate).getTime() : 0
          vb = b.endDate ? new Date(b.endDate).getTime() : 0
        }
        return (va - vb) * dir
      })
      return rows
    },
    detailReduceRows() {
      const rows = (this.detail.reductions || []).slice()
      const { field, order } = this.lastReduceSort
      const dir = order === 'descending' ? -1 : 1
      rows.sort((a, b) => {
        if (field === 'createdAt') {
          const ta = a.createdAt || ''
          const tb = b.createdAt || ''
          return (ta < tb ? -1 : ta > tb ? 1 : 0) * dir
        }
        const va = field === 'reduceDays' ? (a.reduceDays || 0) : 0
        const vb = field === 'reduceDays' ? (b.reduceDays || 0) : 0
        return (va - vb) * dir
      })
      return rows
    },
    // 守纪标兵：从未被罚站过的学生（站完/减罚完都算被罚过），按学号升序
    exemplaryRows() {
      return this.allRows
        .filter(r => !r.hasPenaltyRecord)
        .slice()
        .sort((a, b) => (Number(a.studentNumber) || 0) - (Number(b.studentNumber) || 0))
    },
    displayRows() {
      const base = this.onlyPenalized
        ? this.allRows.filter(r => r.remainingDays > 0)
        : this.allRows.slice()
      const { field, order } = this.lastSort
      const dir = order === 'descending' ? -1 : 1
      base.sort((a, b) => {
        let va = 0
        let vb = 0
        if (field === 'studentNumber') {
          va = Number(a.studentNumber) || 0
          vb = Number(b.studentNumber) || 0
        } else if (field === 'remainingDays') {
          va = a.remainingDays || 0
          vb = b.remainingDays || 0
        } else if (field === 'endDate') {
          va = a.endDate ? new Date(a.endDate).getTime() : 0
          vb = b.endDate ? new Date(b.endDate).getTime() : 0
        } else if (field === 'disciplineDays') {
          va = a.disciplineDays || 0
          vb = b.disciplineDays || 0
        }
        return (va - vb) * dir
      })
      return base
    }
  },
  created() {
    this.loadConfig()
    this.loadList()
  },
  mounted() {
    // 表格按住拖拽横向滚动（鼠标）：document 级委托，append-to-body 弹窗内也生效
    document.addEventListener('mousedown', this.onDragScrollStart)
    document.addEventListener('mousemove', this.onDragScrollMove)
    document.addEventListener('mouseup', this.onDragScrollEnd)
    // 触摸版（手机/F12 设备模拟）：空白区域在滚动容器外，原生触摸滚的是页面，需要接管横向拖动
    document.addEventListener('touchstart', this.onDragTouchStart, { passive: false })
    document.addEventListener('touchmove', this.onDragTouchMove, { passive: false })
    document.addEventListener('touchend', this.onDragTouchEnd)
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.onDragScrollStart)
    document.removeEventListener('mousemove', this.onDragScrollMove)
    document.removeEventListener('mouseup', this.onDragScrollEnd)
    document.removeEventListener('touchstart', this.onDragTouchStart)
    document.removeEventListener('touchmove', this.onDragTouchMove)
    document.removeEventListener('touchend', this.onDragTouchEnd)
  },
  methods: {
    onDragTouchStart(e) {
      if (!e.touches || e.touches.length !== 1) return
      const t = e.target.closest ? e.target.closest('.pf-drag-scroll') : null
      if (!t) return
      // 滚动容器内（数据行）交给原生触摸滚动
      if (e.target.closest('.el-table__body-wrapper')) return
      const wrapper = t.querySelector('.el-table__body-wrapper')
      if (!wrapper) return
      // 这里不能立即 preventDefault：会吞掉后续 click（表头排序点击失效）
      // 只记录起点，等确认横向拖动后再接管
      this._touchState = {
        wrapper,
        startX: e.touches[0].clientX,
        startY: e.touches[0].clientY,
        startLeft: wrapper.scrollLeft,
        taken: false
      }
    },
    onDragTouchMove(e) {
      const s = this._touchState
      if (!s) return
      if (!s.taken) {
        const dx = Math.abs(e.touches[0].clientX - s.startX)
        const dy = Math.abs(e.touches[0].clientY - s.startY)
        if (dx < 8) return // 位移太小，视为点击前的微动，不接管
        if (dx <= dy) { this._touchState = null; return } // 纵向滑动交给页面滚动
        s.taken = true // 确认横向拖动，从现在起拦截
      }
      s.wrapper.scrollLeft = s.startLeft - (e.touches[0].clientX - s.startX)
      e.preventDefault()
    },
    onDragTouchEnd() {
      this._touchState = null
    },
    onDragScrollStart(e) {
      if (e.button !== 0) return
      // 空白处按下时 target 是表格根元素（不在滚动容器内），所以先找最近的表格再取它的滚动容器
      const table = e.target.closest ? e.target.closest('.pf-drag-scroll') : null
      if (!table) return
      const wrapper = table.querySelector('.el-table__body-wrapper')
      if (!wrapper) return
      // 不在 mousedown 上 preventDefault（会破坏点击语义），防选中交给 pf-dragging-table 的 user-select
      this._dragState = { wrapper, startX: e.clientX, startLeft: wrapper.scrollLeft, moved: false }
    },
    onDragScrollMove(e) {
      const s = this._dragState
      if (!s) return
      const dx = e.clientX - s.startX
      if (!s.moved && Math.abs(dx) > 5) {
        s.moved = true
        document.body.classList.add('pf-dragging-table')
      }
      if (s.moved) {
        s.wrapper.scrollLeft = s.startLeft - dx
        e.preventDefault()
      }
    },
    onDragScrollEnd(e) {
      const s = this._dragState
      this._dragState = null
      document.body.classList.remove('pf-dragging-table')
      if (s && s.moved && e.target) {
        // 拖动结束拦掉后续误触 click（不干扰未拖动时的按钮点击）
        const kill = (ev) => { ev.stopPropagation(); ev.preventDefault() }
        e.target.addEventListener('click', kill, { capture: true, once: true })
        setTimeout(() => e.target.removeEventListener('click', kill, { capture: true }), 120)
      }
    },
    async loadConfig() {
      try {
        const res = await this.$http.get('/penalty/config')
        this.semesterStart = (res.data && res.data.semesterStartDate) || null
        this.makeupDateStrings = (res.data && res.data.makeupDates) || []
      } catch (e) {
        // 未设置或读取失败时降级为不带周标注
        this.semesterStart = null
        this.makeupDateStrings = []
      }
    },
    goBack() {
      this.$router.push(`/mobile/more/${this.classId}`)
    },
    openSetting() {
      this.settingForm.semesterStartDate = this.semesterStart || ''
      this.settingForm.makeupDates = [...this.makeupDateStrings]
      this.settingDialogVisible = true
    },
    async submitSetting() {
      if (!this.settingForm.semesterStartDate) {
        this.$message.warning('请选择开学日期')
        return
      }
      try {
        await this.$http.post('/penalty/config', {
          semesterStartDate: this.settingForm.semesterStartDate,
          makeupDates: this.settingForm.makeupDates
        })
        this.semesterStart = this.settingForm.semesterStartDate
        this.makeupDateStrings = [...(this.settingForm.makeupDates || [])]
        this.settingDialogVisible = false
        this.$message.success('设置已保存')
        // 补课日历变化会影响剩余天数/守纪天数，刷新列表
        this.loadList()
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || '保存失败'
        this.$message.error(msg)
      }
    },
    async clearAllPenalties() {
      try {
        await this.$confirm(
          '将删除本班所有学生的罚站与减罚记录（含历史），操作不可恢复。确定要清空吗？',
          '清空确认',
          { confirmButtonText: '确定清空', cancelButtonText: '取消', type: 'warning' }
        )
      } catch (e) {
        return // 用户取消
      }
      try {
        await this.$http.post('/penalty/clearClass', null, { params: { classId: this.classId } })
        this.$message.success('已清空本班所有罚站与减罚记录')
        this.settingDialogVisible = false
        this.loadList()
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || '清空失败'
        this.$message.error(msg)
      }
    },
    /** 周标注：(周几/第几周)，开学日所在自然周为第一周；开学前或未设置时返回空 */
    weekLabel(dateStr) {
      if (!this.semesterStart || !dateStr) return ''
      const start = new Date(this.semesterStart + 'T00:00:00')
      const d = new Date(dateStr + 'T00:00:00')
      if (isNaN(d.getTime()) || d < start) return ''
      const day = (d.getDay() + 6) % 7
      const startDay = (start.getDay() + 6) % 7
      const monday = new Date(start)
      monday.setDate(start.getDate() - startDay)
      const week = Math.floor((d.getTime() - monday.getTime()) / (7 * 86400000)) + 1
      // 格式：(第几周/周几)，周几用阿拉伯数字（周一=1 ... 周日=7）
      return '(' + week + '/' + (day + 1) + ')'
    },
    /** 日期显示：去年份 + 周标注，如 09-21(3/1) 表示第3周周一 */
    fmtDateFull(dateStr) {
      if (!dateStr) return '-'
      return String(dateStr).substring(5, 10) + this.weekLabel(String(dateStr).substring(0, 10))
    },
    openExemplaryDialog() {
      // 打开前刷新列表，保证"从未被罚站"数据最新
      this.loadList().then(() => {
        this.exemplaryDialogVisible = true
      })
    },
    async loadList() {
      this.loading = true
      try {
        const res = await this.$http.get('/penalty/list', {
          params: { classId: this.classId, onlyPenalized: false }
        })
        this.allRows = Array.isArray(res.data) ? res.data : []
      } catch (e) {
        this.$message.error('获取罚站列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSortChange({ column, prop, order }) {
      // 与彻查作业弹窗一致：取消排序时，按与上次相反的方向排序
      if (order === null) {
        order = this.lastSort.order === 'descending' ? 'ascending' : 'descending'
      }

      // 确保同一时刻只有一列处于排序状态
      if (this.$refs.penaltyTable) {
        const columns = this.$refs.penaltyTable.columns
        columns.forEach(col => {
          if (col.property !== prop) {
            col.order = null
          }
        })
        const currentColumn = columns.find(col => col.property === prop)
        if (currentColumn) {
          currentColumn.order = order
        }
      }

      this.lastSort = {
        field: prop,
        order: order
      }
    },
    fmtDate(d) {
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    openAddDialog() {
      const now = new Date()
      let d = new Date(now)
      const day = d.getDay()
      // 未补课的周末顺延到下周一；补课的周末当天可选
      const isMakeup = this.makeupDateStrings.includes(this.fmtDate(d))
      if (day === 6 && !isMakeup) {
        d.setDate(d.getDate() + 2)
      } else if (day === 0 && !isMakeup) {
        d.setDate(d.getDate() + 1)
      }
      this.addForm = {
        studentIds: [],
        punishDate: this.fmtDate(d),
        punishPeriod: (now.getHours() > 10 || (now.getHours() === 10 && now.getMinutes() >= 45)) ? 2 : 1,
        violationContent: '',
        days: 1,
        restrictReduce: false
      }
      this.addDialogVisible = true
    },
    async submitAdd() {
      if (!this.addForm.studentIds.length) {
        this.$message.warning('请选择学生')
        return
      }
      if (!this.addForm.punishDate) {
        this.$message.warning('请选择处罚日期')
        return
      }
      if (!this.addForm.violationContent.trim()) {
        this.$message.warning('请填写违纪内容')
        return
      }
      if (!this.addForm.days || this.addForm.days < 1) {
        this.$message.warning('罚站天数必须大于0')
        return
      }
      try {
        await this.$http.post('/penalty/add', {
          classId: Number(this.classId),
          studentIds: this.addForm.studentIds,
          punishDate: this.addForm.punishDate,
          punishPeriod: this.addForm.punishPeriod,
          violationContent: this.addForm.violationContent.trim(),
          days: this.addForm.days,
          restrictReduce: this.addForm.restrictReduce
        })
        this.$message.success('添加成功')
        this.addDialogVisible = false
        this.loadList()
      } catch (e) {
        const msg = e.response && e.response.data && e.response.data.message
        this.$message.error(msg || '添加惩罚失败')
      }
    },
    onReduceClick(row) {
      if (row.restrictReduce === 1) {
        this.$message.warning('该错误较严重，已限制减罚')
        return
      }
      this.openReduceDialog(row)
    },
    openReduceDialog(recordRow) {
      const effective = recordRow.currentDays == null ? 0 : recordRow.currentDays
      if (effective < 1) {
        this.$message.info('该条处罚已全部减完，无法再减')
        return
      }
      this.reduceTarget = {
        recordId: recordRow.id,
        studentName: this.detailTarget.name,
        punishLabel: this.fmtDateFull(recordRow.punishDate) + ' ' + (recordRow.punishPeriod === 2 ? '下午' : '上午'),
        days: recordRow.days,
        effectiveDays: effective
      }
      this.reduceForm = {
        reduceDays: 1,
        reason: ''
      }
      this.reduceDialogVisible = true
    },
    async submitReduce() {
      if (!this.reduceForm.reduceDays || this.reduceForm.reduceDays < 1) {
        this.$message.warning('减罚天数必须大于0')
        return
      }
      if (this.reduceForm.reduceDays > this.reduceTarget.effectiveDays) {
        this.$message.warning('减罚天数不能超过该条记录当前生效天数')
        return
      }
      try {
        await this.$http.post('/penalty/reduce', {
          recordId: this.reduceTarget.recordId,
          reduceDays: this.reduceForm.reduceDays,
          reason: this.reduceForm.reason.trim()
        })
        this.$message.success('减罚成功')
        this.reduceDialogVisible = false
        this.openDetailDialog(this.detailTarget)
        this.loadList()
      } catch (e) {
        const msg = e.response && e.response.data && e.response.data.message
        this.$message.error(msg || '减罚失败')
      }
    },
    /** 登记天数公式显示：无减罚显示 3，有减罚显示 3-2=1 */
    daysFormula(row) {
      const list = (this.detail.reductions || []).filter(r => r.recordId === row.id)
      if (!list.length) return String(row.days)
      let expr = String(row.days)
      let sum = 0
      list.forEach(r => {
        expr += '-' + (r.reduceDays || 0)
        sum += r.reduceDays || 0
      })
      return expr + '=' + Math.max(row.days - sum, 0)
    },
    /** 减罚对象显示：对应罚站的处罚时间，无关联时显示"历史" */
    recordLabel(recordId) {
      if (!recordId) return '历史'
      const rec = (this.detail.penaltyRecords || []).find(p => p.id === recordId)
      if (!rec) return '历史'
      return this.fmtDateFull(rec.punishDate) + (rec.punishPeriod === 2 ? '下午' : '上午')
    },
    openEditDialog(row) {
      this.editTarget = {
        studentId: this.detailTarget.studentId,
        name: this.detailTarget.name
      }
      this.editForm = {
        id: row.id,
        punishDate: row.punishDate,
        punishPeriod: row.punishPeriod,
        violationContent: row.violationContent,
        days: row.days,
        restrictReduce: row.restrictReduce === 1
      }
      this.editReductions = (this.detail.reductions || []).filter(r => r.recordId === row.id)
      this.editingReductionId = null
      this.editDialogVisible = true
    },
    async submitEdit() {
      if (!this.editForm.punishDate) {
        this.$message.warning('请选择处罚日期')
        return
      }
      if (!this.editForm.violationContent.trim()) {
        this.$message.warning('请填写违纪内容')
        return
      }
      if (!this.editForm.days || this.editForm.days < 1) {
        this.$message.warning('罚站天数必须大于0')
        return
      }
      try {
        await this.$http.post('/penalty/updatePenaltyRecord', {
          id: this.editForm.id,
          punishDate: this.editForm.punishDate,
          punishPeriod: this.editForm.punishPeriod,
          violationContent: this.editForm.violationContent.trim(),
          days: this.editForm.days,
          restrictReduce: this.editForm.restrictReduce
        })
        this.$message.success('修改成功')
        this.editDialogVisible = false
        this.openDetailDialog(this.detailTarget)
        this.loadList()
      } catch (e) {
        const msg = e.response && e.response.data && e.response.data.message
        this.$message.error(msg || '编辑失败')
      }
    },
    startEditReduction(r) {
      this.editingReductionId = r.id
      this.editReductionForm = {
        reduceDays: r.reduceDays,
        reason: r.reason || ''
      }
    },
    async saveEditReduction(r) {
      if (!this.editReductionForm.reduceDays || this.editReductionForm.reduceDays < 1) {
        this.$message.warning('减罚天数必须大于0')
        return
      }
      const otherSum = this.editReductions
        .filter(x => x.id !== r.id)
        .reduce((s, x) => s + (x.reduceDays || 0), 0)
      if (this.editReductionForm.reduceDays + otherSum > this.editForm.days) {
        this.$message.warning('减罚总天数不能超过登记天数（' + this.editForm.days + ' 天）')
        return
      }
      try {
        await this.$http.post('/penalty/updatePenaltyReduction', {
          id: r.id,
          reduceDays: this.editReductionForm.reduceDays,
          reason: this.editReductionForm.reason.trim()
        })
        this.$message.success('修改成功')
        this.editingReductionId = null
        await this.openDetailDialog(this.detailTarget)
        this.editReductions = (this.detail.reductions || []).filter(x => x.recordId === this.editForm.id)
      } catch (e) {
        const msg = e.response && e.response.data && e.response.data.message
        this.$message.error(msg || '修改失败')
      }
    },
    async delEditReduction(r) {
      this.$confirm('删除后对应减罚天数将加回罚站，确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await this.$http.post('/penalty/deletePenaltyReduction', null, { params: { id: r.id } })
          this.$message.success('删除成功')
          await this.openDetailDialog(this.detailTarget)
          this.editReductions = (this.detail.reductions || []).filter(x => x.recordId === this.editForm.id)
          this.loadList()
        } catch (e) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    handleDetailPenaltySort({ prop, order }) {
      // 与罚站总表一致：取消排序时，按与上次相反的方向排序
      if (order === null) {
        order = this.lastPenaltySort.order === 'descending' ? 'ascending' : 'descending'
      }
      this.applySingleColumnSort('detailPenaltyTable', prop, order)
      this.lastPenaltySort = {
        field: prop,
        order: order
      }
    },
    handleDetailReduceSort({ prop, order }) {
      if (order === null) {
        order = this.lastReduceSort.order === 'descending' ? 'ascending' : 'descending'
      }
      this.applySingleColumnSort('detailReduceTable', prop, order)
      this.lastReduceSort = {
        field: prop,
        order: order
      }
    },
    // 确保同一时刻只有一列处于排序状态
    applySingleColumnSort(tableRef, prop, order) {
      const table = this.$refs[tableRef]
      if (!table) return
      table.columns.forEach(col => {
        if (col.property !== prop) {
          col.order = null
        }
      })
      const currentColumn = table.columns.find(col => col.property === prop)
      if (currentColumn) {
        currentColumn.order = order
      }
    },
    // 罚站中淡橙、已站完/已减完淡绿
    penaltyRowClass({ row }) {
      if (row.status === '罚站中') {
        return 'pf-row-ongoing'
      }
      return 'pf-row-done'
    },
    async openDetailDialog(row) {
      this.detailTarget = {
        studentId: row.studentId,
        name: row.name
      }
      this.detail = {
        penaltyRecords: [],
        reductions: []
      }
      this.detailTab = 'penalty'
      this.lastPenaltySort = {
        field: 'punishDate',
        order: 'descending'
      }
      this.lastReduceSort = {
        field: 'createdAt',
        order: 'descending'
      }
      this.detailDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.detailPenaltyTable) {
          this.$refs.detailPenaltyTable.sort('punishDate', 'descending')
        }
        if (this.$refs.detailReduceTable) {
          this.$refs.detailReduceTable.sort('createdAt', 'descending')
        }
      })
      try {
        const res = await this.$http.get('/penalty/detail', {
          params: { classId: this.classId, studentId: row.studentId }
        })
        this.detail = {
          penaltyRecords: (res.data && res.data.penaltyRecords) || [],
          reductions: (res.data && res.data.reductions) || []
        }
      } catch (e) {
        this.$message.error('获取详情失败')
      }
    },
    delPenaltyRecord(row) {
      this.$confirm('删除后该生的罚站接龙将自动重排，确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await this.$http.post('/penalty/deletePenaltyRecord', null, { params: { id: row.id } })
          this.$message.success('删除成功')
          this.openDetailDialog(this.detailTarget)
          this.loadList()
        } catch (e) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    delReduction(row) {
      this.$confirm('删除后对应减罚天数将加回罚站，确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await this.$http.post('/penalty/deletePenaltyReduction', null, { params: { id: row.id } })
          this.$message.success('删除成功')
          this.openDetailDialog(this.detailTarget)
          this.loadList()
        } catch (e) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.penalty-free-mobile {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
  padding-top: 44px;
}

.pf-content {
  flex: 1;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pf-header {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.pf-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pf-title-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.pf-title-line {
  display: flex;
  align-items: center;
}

.back-btn {
  padding: 5px 10px;
  margin-right: 10px;
}

.pf-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.pf-subtitle {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.pf-setting-btn {
  background: #e8f8f6;
  border: none;
  color: #13b5a6;
  padding: 8px 10px;
}

.pf-add-btn {
  background: linear-gradient(135deg, #40e0d0, #6abfd1);
  border: none;
  color: #fff;
  font-weight: bold;
}

.pf-switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #f0f2f5;
}

.pf-switch-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pf-title-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pf-switch-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pf-switch-actions .pf-add-btn {
  padding: 9px 10px;
}

.pf-exemplary-btn {
  background: #e8f8f6;
  border: none;
  color: #13b5a6;
  font-weight: bold;
}

/* 守纪标兵弹窗：青色渐变横幅 + 名单卡片 */
.pf-exemplary-dialog ::v-deep .el-dialog {
  border-radius: 12px;
}
.pf-exemplary-banner {
  background: linear-gradient(135deg, #40e0d0, #6abfd1);
  border-radius: 10px;
  padding: 16px;
  text-align: center;
  color: #fff;
  margin-bottom: 12px;
}
.pf-exemplary-medal {
  font-size: 34px;
}
.pf-exemplary-title {
  font-size: 17px;
  font-weight: bold;
  margin-top: 4px;
}
.pf-exemplary-slogan {
  font-size: 13px;
  margin-top: 6px;
  opacity: 0.95;
  line-height: 1.5;
}
.pf-exemplary-slogan-main {
  display: block;
  text-align: left;
}
.pf-exemplary-slogan-sub {
  display: block;
  text-align: right;
}
.pf-exemplary-item {
  display: flex;
  align-items: center;
  padding: 9px 12px;
  border-bottom: 1px dashed #ebeef5;
}
.pf-exemplary-item:last-child {
  border-bottom: none;
}
.pf-exemplary-no {
  color: #909399;
  font-size: 13px;
  width: 44px;
}
.pf-exemplary-name {
  flex: 1;
  color: #303133;
  font-size: 14px;
  font-weight: bold;
}
.pf-exemplary-check {
  color: #40e0d0;
  font-size: 16px;
}
.pf-exemplary-empty {
  text-align: center;
  color: #909399;
  font-size: 13px;
  padding: 24px 0;
}
.pf-exemplary-footer {
  text-align: center;
  color: #13b5a6;
  font-size: 13px;
  padding-top: 10px;
}

.pf-switch-label {
  font-size: 14px;
  color: #303133;
}

.pf-table-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #a8e6de;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* 表头排序三角与文字保持同行 */
.pf-table-card ::v-deep .el-table th .cell {
  white-space: nowrap;
}

/* el-table 默认 overflow:hidden 会让 sticky 表头失效，改为 visible；主列表字体 14px
   表格 flex:1 撑满卡片（即视口剩余高度），flex 拉伸 body-wrapper 让横向滚动条贴在表格最底部 */
.pf-table-card ::v-deep .el-table {
  flex: 1;
  overflow: visible;
  font-size: 14px;
  min-height: 320px !important;
  display: flex;
  flex-direction: column;
}
.pf-table-card ::v-deep .el-table__body-wrapper {
  flex: 1;
}
.pf-table-card ::v-deep .el-table__empty-block {
  min-height: 230px;
}

/* 页面往下拉时固定表头：顶栏会整体上移隐藏，表头直接贴屏幕顶 */
.pf-table-card ::v-deep .el-table__header-wrapper {
  position: sticky;
  top: 0;
  z-index: 10;
  border-radius: 9px 9px 0 0;
  background: #fff;
}

/* 数字加减框：补齐四周圆角，避免边框缺角 */
.pf-days-number ::v-deep .el-input__inner {
  border-radius: 4px;
  transform: translateZ(0);
}
.pf-days-number ::v-deep .el-input-number__decrease {
  border-radius: 4px 0 0 4px;
}
.pf-days-number ::v-deep .el-input-number__increase {
  border-radius: 0 4px 4px 0;
}

/* 详情弹窗内表格用 el-table 原生 max-height 固定表头，不用 sticky */

/* 弹窗内容紧凑化 + 青色 header（与移动端主题一致）
   padding 上下对称 13px（+24px 标题行高 = 50px），标题文字上下居中 */
.pf-dialog ::v-deep .el-dialog__header {
  background: linear-gradient(90deg, #13b5a6, #3ec6b7) !important;
  padding-top: 13px;
  padding-bottom: 13px;
}
.pf-dialog ::v-deep .el-dialog__body {
  padding-top: 6px;
  padding-bottom: 12px;
}

/* 关闭按钮在 header 内上下居中（header高50px、按钮高30px） */
.pf-dialog ::v-deep .el-dialog__headerbtn {
  top: 10px;
}

/* 详情弹窗合适的初始高度 */
.pf-detail-dialog ::v-deep .el-dialog {
  min-height: 420px;
}

/* 弹窗内表头排序三角与文字保持同行（inline-flex 强制单行） */
.pf-dialog ::v-deep .el-table th .cell {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

/* 详情弹窗行底色：罚站中淡橙，已站完/已减完淡绿
   悬停/点击时背景色完全不变化（transparent 压掉 Element UI 的 hover 效果） */
.pf-dialog ::v-deep .el-table .pf-row-ongoing td,
.pf-dialog ::v-deep .el-table tr.pf-row-ongoing:hover td {
  background-color: #fdf6ec !important;
}
.pf-dialog ::v-deep .el-table .pf-row-done td,
.pf-dialog ::v-deep .el-table tr.pf-row-done:hover td {
  background-color: #f0f9eb !important;
}
.pf-dialog ::v-deep .el-table tbody tr:hover > td {
  background-color: transparent !important;
}

/* 详情弹窗两个表格恒定高度 + 淡青圆角边框（撑开的高度看得见）
   mini 表格默认 12px，显式设为 14px 与主列表一致 */
.pf-dialog ::v-deep .el-table.pf-detail-table {
  min-height: 320px !important;
  font-size: 14px;
  border: 1px solid #a8e6de;
  border-radius: 10px;
  overflow: hidden;
  /* 外壳变 flex 容器，让内部滚动容器拉伸填满，横向滚动条贴在表格最底部 */
  display: flex;
  flex-direction: column;
}
.pf-dialog ::v-deep .el-table.pf-detail-table .el-table__body-wrapper {
  flex: 1;
}
.pf-dialog ::v-deep .el-table.pf-detail-table th {
  background-color: #e8f8f6;
}
.pf-dialog ::v-deep .el-table__empty-block {
  min-height: 230px;
}

/* 按住拖拽横向滚动：抓取光标反馈 + 拖动中禁止选中文本 */
.pf-drag-scroll .el-table__body-wrapper {
  cursor: grab;
}
body.pf-dragging-table,
body.pf-dragging-table * {
  cursor: grabbing !important;
  user-select: none !important;
}

/* 操作列按钮同行排列，不换行不错位 */
.pf-dialog ::v-deep .el-table .pf-op-col .cell {
  white-space: nowrap;
  vertical-align: middle;
}
.pf-dialog ::v-deep .el-table .pf-op-col .el-button {
  vertical-align: middle;
}

.pf-action-btn {
  padding: 0;
  margin: 0 6px 0 0;
  color: #13b5a6;
  font-size: 14px;
}

/* 限制减罚时的置灰按钮 */
.pf-btn-disabled {
  color: #c0c4cc !important;
}

/* 限制减罚开关行：开关与说明文案间距 */
.pf-restrict-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pf-restrict-tip {
  font-size: 12px;
  color: #909399;
}

/* "限制减罚"非必填项，用隐形星号占位与上面带*号的标题对齐 */
.pf-label-placeholder {
  visibility: hidden;
}

.pf-del-btn {
  padding: 0;
  margin: 0;
  color: #f56c6c;
  font-size: 14px;
}

/* 设置弹窗危险操作区 */
.pf-danger-zone {
  margin-top: 4px;
  padding-top: 12px;
  border-top: 1px dashed #f0c8c8;
}
.pf-danger-btn {
  color: #f56c6c;
  border-color: #fbc4c4;
}
.pf-danger-btn:hover,
.pf-danger-btn:focus {
  color: #fff;
  background-color: #f56c6c;
  border-color: #f56c6c;
}

.pf-datetime-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pf-period-group {
  flex-shrink: 0;
}

.pf-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
  line-height: 1.5;
}

.pf-reduce-context {
  background: #e8f8f6;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  color: #13b5a6;
  line-height: 1.6;
  margin-bottom: 12px;
}

.pf-edit-reduction-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px dashed #ebeef5;
}

.pf-edit-reduction-row:last-child {
  border-bottom: none;
}

.pf-er-days {
  font-size: 13px;
  font-weight: bold;
  color: #e6a23c;
  white-space: nowrap;
}

.pf-er-reason {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pf-primary-btn {
  background: linear-gradient(135deg, #40e0d0, #6abfd1);
  border: none;
  color: #fff;
}

.pf-section-title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  margin: 6px 0 8px;
}

.pf-section-title + .el-table {
  margin-bottom: 14px;
}
</style>
